import TagManager from 'react-gtm-module';

export const initAnalytics = () => {
  const tmTrackingID = process.env.REACT_APP_TM_TRACKING_ID;

  if (tmTrackingID !== undefined) {
    TagManager.initialize({
      gtmId: tmTrackingID, // GTM Code
    });
  }
};

/**
 * Trach the current location.
 */
export const AnalyticsPageView = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      pagePath: window.location.pathname,
    },
  });
};

/**
 * Event - Add custom tracking event.
 * @param {string} event
 * @param {string} action
 * @param {string} label
 */
export const AnalyticsEvent = (event: string, action: string, label: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event,
      action,
      data: label,
    },
  });
};
